<template>
  <component
    :is="tooltipComponent"
    :message="message"
    :to="link"
    class="c-swatch"
    position="bottom"
    aria-hidden="true"
    role="button"
    @click.native="$emit(eventType, color)"
  >
    <div
      v-if="image"
      class="c-swatch__color-image"
      :class="{
        'l-flex': true,
        'c-swatch__color-image--active' : active
      }"
    >
      <div
        class="c-swatch__color-middle"
        :class="{
          'c-swatch__color-middle--active': active,
          'c-swatch__color-middle--diamond': needsBorder
        }"
        :style="image"
      />
    </div>
    <div
      v-else-if="hue.length"
      class="c-swatch__color-image"
      :class="{
        'l-flex': true,
        'c-swatch__color-image--active': active
      }"
    >
      <div
        class="c-swatch__color-middle"
        :class="{
          'c-swatch__color-middle--active': active,
          'c-swatch__color-middle--white': needsBorder
        }"
        :style="image"
      />
    </div>
    <div
      v-else-if="finish && finish.title"
      class="c-swatch__finish"
      :class="{'c-swatch__finish--active': finish.active}"
    >
      <div
        class="c-swatch__finish-middle"
        :class="{
          'c-swatch__finish-middle--white': needsBorder
        }"
      />
      {{ finish.finish }}
    </div>
    <div
      v-else
      class="c-swatch__color-image"
      :class="{
        'l-flex': true,
        'c-swatch__color-image--active' : active
      }"
    >
      <div
        class="c-swatch__color-middle"
        :class="{
          'c-swatch__color-middle--active': active,
          'c-swatch__color-middle--diamond': needsBorder
        }"
        :style="image"
      />
    </div>
    <div
      v-if="showLabel"
      class="c-swatch__label"
      :class="[
        'u-center-text'
      ]"
    >
      {{ color.name }}
    </div>
  </component>
</template>

<script>
import get from 'lodash/get'
import isArray from 'lodash/isArray'
import SwatchLink from './SwatchLink'
import SwatchWrapper from './SwatchWrapper'
import Tooltip from "../tooltip/Tooltip";
import TooltipLink from "../tooltip/TooltipLink";
import trim from 'lodash/trim'
export default {
  components: {
    SwatchLink,
    SwatchWrapper,
    Tooltip,
    TooltipLink,
  },
  props:{
    finish: {
      type: Object,
      default: null
    },
    active: {
      type: Boolean,
      default: false
    },
    color: {
      type: Object,
      required: true
    },
    showImage: {
      type: Boolean,
      default: false
    },
    renderLink: {
      type: Boolean,
      default: false
    },
    // one of never, always, active
    showLabelWhen: {
      type: String,
      default: 'never'
    },
    eventType: {
      type: String,
      default: 'click'
    },
    tooltip: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      colors: [
        { hue: 'black',  color: 'black' },
        { hue: 'blue',  color: 'rgb(68, 105, 234)' },
        { hue: 'purple',  color: '#5B445E' },
        { hue: 'pink',  color: 'linear-gradient(rgb(219, 114, 139), rgb(219, 114, 139))' },
        { hue: 'white',  color: '#fff' },
        { hue: 'red',  color: 'rgb(172, 24, 24)' },
        { hue: 'green',  color: 'linear-gradient(rgb(14, 110, 61), rgb(14, 110, 61))' },
        { hue: 'orange',  color: 'rgb(254, 102, 46)' },
        { hue: 'yellow',  color: '#fff596' },
        { hue: 'silver',  color: 'rgb(175, 179, 188)' },
        { hue: 'copper',  color: 'rgb(223, 150, 107)' },
        { hue: 'gold',  color: 'rgb(247, 199, 113)' },
        { hue: 'gray',  color: 'rgb(105, 112, 123)' },
        { hue: 'navy blue',  color: 'rgb(50, 56, 72)' },
        { hue: 'brown',  color: 'rgb(94, 76, 61)' },
        { hue: 'rainbow',  color: 'linear-gradient(to left, #FE3636, #FE9327, #FEF35B, #24B024, #2670AD, #A927D7)' },
      ]
    }
  },
  computed: {
    tooltipComponent() {
      const renderLink = this.renderLink
      const tooltip = this.tooltip
      let result = 'swatch-wrapper'
      if (tooltip) {
        result = (renderLink) ? 'tooltip-link' : 'tooltip'
      } else if (renderLink) {
        result = 'swatch-link'
      }
      return result
    },
    needsBorder() {
      const color = this.color
      return (
        color.name === 'Diamond' ||
        color.name === 'Opal' ||
        get(color, 'hue', '').includes('White')
      )
    },
    showLabel() {
      const showLabelWhen = this.showLabelWhen
      const active = this.active
      let result = false
      switch (showLabelWhen) {
      case 'never':
        break
      case 'active':
        result = active
        break
      case 'always':
        result = true
        break
      }
      return result
    },
    message() {
      const finish = this.finish
      const color = this.color
      const active = this.active
      let name
      let description

      if(finish){
        name = finish.title
      }
      else {
        name = color.name
        description = color.description
      }

      if(active){
        description +=  ' This is currently selected.'
      }

      return (name && description)
        ? `${name}: ${description}`
        : name
    },
    link() {
      return `/products/${get(this.color, 'handle')}`
    },
    image() {
      const { swatchImage, swatchColor, name: colorName } = this.color
      let result = ''
      let colorSwatch = this.colors.find(e => {
        return (colorName || '').toLowerCase() == e.hue
      })
      if (swatchColor || (swatchColor == undefined && this.color.name)) {
        if(this.showImage)
          result = swatchImage == ''
            ? `background: ${swatchColor}`
            : `background-image: url("//${swatchImage}");`
        else 
          result = `background: ${colorSwatch != undefined ? colorSwatch.color : swatchColor}`;
      }
      else if (swatchImage) {
        result = `background-image: url("//${swatchImage}");`
      }
      return result
    },
    hue() {
      const color = this.color
      return this.getHue(color)
    }
  },
  methods: {
    getHue({ hue }) {
      let result = []
      if (hue) {
        if (isArray(hue)) {
          for (let item of hue) {
            result.push(...this.getHue(item))
          }
        } else if (hue && hue.includes(',')) {
          result.push(...hue.split(',').map(trim))
        } else if (hue) {
          result.push(hue)
        }
      }
      return result
    }
  },
}
</script>

<style lang="scss" scoped>
.c-swatch {
  cursor: pointer;
  position: relative;
  &__color-image {
    /* this has to be in pixels sorry */
    padding: 1px;
    background-size: rem(50px) rem(50px);
    border-radius: rem(50px);
    border: 1px solid $white;
    &:hover, &--active {
      @include themify($themes) {
        border-color: themed('foreground', 'selected');
      }
    }
  }
  &__color-middle {
    height: 52px;
    width: 52px;
    line-height: 52px;
    border-radius: 52px;
    margin: auto;
    background-size: contain;

    @include themify($themes) {
      border: 1px solid themed('foreground', 'select');
    }
    &--white {
      border: 1px solid black;
    }
    &--diamond {
      border: 1px solid black;
    }
    &--active::after {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      content: url("../../../public/icon/check.svg");
    }
  }
  &__label {
    position: absolute;
    width: rem(100px);
    left: -50%;
    @include themify($themes) {
      color: themed('foreground', 'text');
    }
  }
}

</style>
